import { Link as MuiLink, LinkProps } from '@mui/material';
import { ForwardedRef, forwardRef } from 'react';
import { Link as ReactRouterLink, useLocation } from 'react-router-dom';

type CustomLinkProps = {
  href?: string;
  preserveSearchParams?: boolean;
} & LinkProps;

export const CustomLink = forwardRef(
  (props: CustomLinkProps, ref: ForwardedRef<HTMLAnchorElement>) => {
    const isExternal = props.href?.startsWith('https');
    const location = useLocation();
    const { preserveSearchParams, ...otherProps } = props;

    let to = props.href ?? '#';

    // If preserveSearchParams is true and there are search params, append them to the destination URL
    if (preserveSearchParams && location.search && !isExternal) {
      to = `${to}${location.search}`;
    }

    return (
      <MuiLink
        {...otherProps}
        component={ReactRouterLink}
        to={to}
        target={isExternal ? '_blank' : undefined}
        underline={props.underline ?? 'none'}
        ref={ref}
      />
    );
  },
);
